import React from "react";

const BlogTags = () => {
  const tags = [
    { label: "All posts", link: "#", active: true },
    { label: "#AllergyFriendlySnacks", link: "#" },
    { label: "#BonvieSnacks", link: "#" },
    { label: "#CleanIngredients", link: "#" },
    { label: "#FitnessSnack", link: "#" },
  ];

  return (
    <div className="w-full text-center overflow-x-auto whitespace-nowrap py-4">
      <ul className="inline-flex items-center gap-6 px-4">
        {tags.map((tag, index) => (
          <li key={index}>
            <a
              href={tag.link}
              className={`font-medium ${
                tag.active ? "border-b-2 border-black pb-1" : ""
              } hover:underline transition`}
            >
              {tag.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogTags;
